/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

require('components/common/table-data/table-data');
require('components/common/search-tool/search-tool');
require('components/common/date-time/date-time')
require('components/base/input-box/input-box');
require('components/base/btn/btn');
require('components/base/loading/loading');

const store = require('appVuex/store');
const tip = require('components/base/pop/tip');
const confirm = require('components/base/pop/confirm');
const configPushMixin = require('../../mixin')
const ajaxHttp = require('appUtil/ajaxHttp.js')

const { getCityList: cityList } = require('appVuex/getter/common')
const { apiPath } = require('appService/api');

require('./start-ad-list.scss');
const template = require('./start-ad-list.tpl');

const startAdList = {
  name: "start-ad-list",

  template,

  data() {
    return {
      thItems: ["序号", "图片", "广告名称", "闪屏时间", "跳转链接", "是否跳过", "广告生效时间", "客户名称", "客户经理", "平台", "投放城市", "状态", "操作"],
      url: apiPath.configPush.startAd.list,
      queryOpt: {}
    }
  },

  mixins: [configPushMixin],

  store,

  vuex: {
    getters: {
      cityList
    }
  },

  watch: {
    cityList(val) {
      this.$refs.tableData.fetch()
    }
  },

  methods: {
    fetchQuery({queryValue}) {
      this.$refs.tableData.query(queryValue).fetch()
    },

    offlineDisplay(status) {
      return status === 0 || status === 2
    },

    offLine(id) {
      let self = this

      confirm({
        message: '确定下架广告？',
        cb(confirm) {
          confirm.hide()

          ajaxHttp(apiPath.configPush.startAd.stop, {
            data: {
              id: id
            }
          }).then((rtn) => {
            self.$refs.tableData.fetch()

            tip('下架成功！')
          }).catch((rtn) => {
            tip(rtn.error)
          })
        }
      })
    }
  }
}

module.exports = startAdList;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/configPush/start-ad/start-ad-list/start-ad-list.js